import { createSlice } from "@reduxjs/toolkit";

export const vrlSlice = createSlice({
	name: "vrl",
	initialState: {
		proyects: [],
		responses: [],
		averageResponses: 0,
		groups: [],
		proyectSelected: {},
        arrayDataCombined: []
	},
	reducers: {
		addPryects: (state, { payload }) => {
			state.proyects = payload;
		},
		addResponses: (state, { payload }) => {
            // console.log(payload)
			state.responses = payload;
		},
		setProyectSelected: (state, { payload }) => {
			state.proyectSelected = payload;
		},
		setGroups: (state, { payload }) => {
			state.groups = payload.groups;
		},
		addOneGrup: (state, { payload }) => {
			console.log(payload);
			state.groups = [...state.groups, ...payload.grup];
		},
        setStorearrayDataCombined: (state, { payload }) => {
            // console.log("save data combined")
            state.arrayDataCombined = payload
        }
		// setAverageResponses: (state, { payload }) => {
		// 	state.averageResponses = payload;
		// },
	},
});

export const { addPryects, addResponses, setProyectSelected, setGroups, addOneGrup, setStorearrayDataCombined } = vrlSlice.actions;
